import { useNavigate } from 'react-router-dom';
import { Event, nip19 } from 'nostr-tools';
import { extractImages } from '../../lib/parser';
import { Camera } from 'lucide-react';

interface MediaGridProps {
    events: Event[];
}

export function MediaGrid({ events }: MediaGridProps) {
    const navigate = useNavigate();

    // Flatten all images into a single array with metadata
    const allImages = events.flatMap(event => {
        const images = extractImages(event.content);
        return images.map((url, index) => ({
            url,
            eventId: event.id,
            index: index,
            noteId: nip19.noteEncode(event.id)
        }));
    });

    if (allImages.length === 0) {
        return (
            <div className="text-center py-20 bg-white dark:bg-surface-900 rounded-lg border border-dashed border-surface-300 dark:border-surface-700">
                <Camera className="w-12 h-12 mx-auto mb-4 text-gray-300 dark:text-gray-600" />
                <p className="text-gray-500 dark:text-gray-400 font-poppins">
                    Henüz medya içerikli entry bulunamadı.
                </p>
            </div>
        );
    }

    return (
        <div className="grid grid-cols-2 md:grid-cols-3 gap-1">
            {allImages.map((image, i) => (
                <div
                    key={`${image.eventId}-${image.index}`}
                    onClick={() => navigate(`/img/${image.noteId}/${image.index}`, {
                        state: {
                            event: events.find(e => e.id === image.eventId)
                        }
                    })}
                    className="relative aspect-square cursor-pointer group overflow-hidden bg-surface-100 dark:bg-surface-800"
                >
                    <img
                        src={image.url}
                        alt={`Media ${i}`}
                        className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                        loading="lazy"
                    />
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300" />
                </div>
            ))}
        </div>
    );
}
